import { h,Fragment } from 'preact';
import Icon from '../utils/icon';
import Image from '../utils/image';

const ProductHighlight = ({
	currentVariant,
	productShippingStatus,
	product,
	highlights,
	description,
	atcSticky,
	quantity,
  isB2b
}) => {
  const shippingStatus = currentVariant?.shippingStatus ? 
                         currentVariant?.shippingStatus : 
                         productShippingStatus ;

  const inventoryQuantity = currentVariant?.inventoryQuantity;
  const negativeInventoryMessage = 
		currentVariant?.negativeInventoryShippingStatus
  const negativeInventoryDTC = 
		currentVariant?.displayNegativeInventoryForDTC
  const shippingStatusArray = shippingStatus?.split('-');
  const isInStock = shippingStatus?.toLowerCase().includes('in stock');
 
  const IconBlock = (iconProps) =>  (
      <>
        <div className='mt-px '>
          {iconProps.iconProps.icon && 
            <Image src={iconProps.iconProps.icon} 
              classes={'w-4 h-4'}
              srcWidths={{ sm: 100, md: 100 }} />}
        </div>
        <div >
          { iconProps.iconProps.title && 
            <div className='uppercase utility-2'>
              {iconProps.iconProps.title}
            </div> }
          { iconProps.iconProps.ctaUrl && 
            <div>
              <a className='body-2' 
                href={iconProps.iconProps.ctaUrl} >
                {iconProps.iconProps.ctaCopy}
              </a>
            </div> }
        </div>
      </>
    )

  return (
    <div>
      <div className={`${atcSticky ? 'atc-sticky:hidden' : ''} border-b border-gray-5 md:py-8 py-6`}>
        <div className={`body-2 flex items-start mb-4 gap-2 ${ isInStock &&  'text-dark-green' }`}>
          <div className='mt-px'>
            {isInStock ? <Icon name="inStock"/> : <Icon name="box"/>}
          </div>
					{
						quantity > inventoryQuantity && 
						currentVariant.availableForSale && 
						negativeInventoryMessage && (isB2b || negativeInventoryDTC) ? (
							<div className="body-2">{negativeInventoryMessage}</div>
						) : shippingStatusArray ? (
							<div>
								{shippingStatusArray?.length > 1 ? (
									<>
										<div className="uppercase utility-2">{shippingStatusArray[0]}</div>
										<div className="text-primary body-2">{shippingStatusArray[1]}</div>
									</>
								) : (
									<div className="body-2">{shippingStatusArray[0]}</div>
								)}
							</div>
						) : null
					}
        </div>
        <div className={'flex items-start gap-2 mb-4'}>
          <IconBlock iconProps={product.secondIconBlock} />
        </div>
        <div className={'flex items-start gap-2 '}>
          <IconBlock iconProps={product.thirdIconBlock} />
        </div>
      </div>
      <div className={`${atcSticky ? 'atc-sticky:mb-0 atc-sticky:p-0 atc-sticky:border-none' : ''} border-b border-gray-5 mb-8 pb-6 pt-8 md:py-8`}>
        <div className={`${atcSticky ? 'atc-sticky:hidden' : ''} body-2 uppercase mb-5 font-medium`}>Highlights</div>
        <div className={`${atcSticky ? 'atc-sticky:hidden' : ''} body-2 ml-0 !max-w-full rte`}>
          <div dangerouslySetInnerHTML={{__html: description}} />
          <div className='mt-5 mb-8'>
            <div dangerouslySetInnerHTML={{__html: highlights}} />
          </div>
        </div>
        <div className='flex justify-between'>
          <div className='flex gap-2'>
            <span className={`${atcSticky ? 'atc-sticky:hidden' : ''} text-primary utility-2`}>{window.TMW.sku}</span> 
            <span className='utility-2-normal text-secondary'>{currentVariant?.sku}</span> 
          </div>
            <a className={`${atcSticky ? 'atc-sticky:hidden' : ''} body-2 cursor-pointer`} onClick={()=>window.print()}>
              {window.TMW.Strings.product.tearSheet}
            </a>  
        </div>
      </div>
    </div>
)};

export default ProductHighlight;
